export enum FeatureKeys {
  AllLanguages = "languages",
  BoxOffersByUser = "boxOffersByUser",
  TimeZone = "timeZone",
  MultipleMedias = "multipleMedias",
}

export const DEFAULT_ACTIVATED_FEATURES: FeatureKeys[] = []

export const DEV_DEFAULT_ACTIVATED_FEATURES: FeatureKeys[] = [FeatureKeys.AllLanguages]
